import Vue from "vue";
import VueRouter from "vue-router";
import HomePage from "../pages/HomePage.vue";
import HotNewsPage from "../pages/HotNewsPage.vue";
import AppSquarePage from "../pages/AppSquarePage.vue";
import MoreArticleListPage from "../pages/MoreArticleListPage.vue";
import DetailPage from "../pages/DetailPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
  },
  {
    path: "/hot",
    name: "hotnews",
    component: HotNewsPage,
  },
  {
    path: "/app",
    name: "appsquare",
    component: AppSquarePage,
  },
  {
    path: "/morearticle",
    name: "morearticle",
    component: MoreArticleListPage,
  },
  {
    path: "/detail",
    name: "detailpage",
    component: DetailPage,
  },
];

const router = new VueRouter({
  routes,
});

// 在路由导航完成后，滚动到页面顶部
router.afterEach(() => {
  window.scrollTo(0, 0);
});

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
